import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function DatenschutzPage() {
  return (
    <div className="min-h-screen pt-28 pb-16" data-testid="datenschutz-page">
      <div className="max-w-3xl mx-auto px-6 sm:px-8 lg:px-12">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-slate-900 transition-colors mb-8" data-testid="datenschutz-back-link">
          <ArrowLeft size={16} />
          Zurück zur Startseite
        </Link>

        <div className="bg-white/60 backdrop-blur-2xl border border-white/80 shadow-[0_8px_32px_rgba(0,0,0,0.04)] rounded-3xl p-8 lg:p-12">
          <h1 className="text-4xl sm:text-5xl font-light tracking-tight text-slate-900 font-['Outfit'] mb-4">Datenschutzerklärung</h1>
          <p className="text-xs text-slate-400 mb-10">Stand: 03. April 2026</p>

          <div className="space-y-8 text-sm leading-relaxed text-slate-600">
            <div>
              <h2 className="text-lg font-semibold text-slate-900 font-['Outfit'] mb-3">1. Datenschutz auf einen Blick</h2>
              <p>
                Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen
                Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit
                denen Sie persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz
                entnehmen Sie unserer nachfolgenden Datenschutzerklärung.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 font-['Outfit'] mb-3">2. Verantwortliche Stelle</h2>
              <p>
                Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:<br /><br />
                <strong className="text-slate-800">JF-NEXUS</strong><br />
                Jens Mäder & Florian Fuß GbR<br />
                Fehnstr. 16, 96317 Kronach<br />
                E-Mail: info@jf-nexus.de<br /><br />
                Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam
                mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten entscheidet.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 font-['Outfit'] mb-3">3. Hosting und Cloud-Dienste</h2>
              <p>
                Unsere Website wird bei einem externen Cloud-Hosting-Dienstleister gehostet. Die personenbezogenen
                Daten, die auf dieser Website erfasst werden, werden auf den Servern des Hosters gespeichert.
                Hierbei kann es sich v. a. um IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten,
                Vertragsdaten, Kontaktdaten, Namen, Websitezugriffe und sonstige Daten handeln.
              </p>
              <p className="mt-3">
                <strong className="text-slate-800">Anbieter ist:</strong><br />
                Emergent Labs, Inc.<br />
                548 Market St, PMB 20117<br />
                San Francisco, CA 94104, USA<br />
                (nachfolgend &bdquo;Emergent&ldquo;)
              </p>
              <p className="mt-3">
                <strong className="text-slate-800">Rechtsgrundlage und Zweck:</strong><br />
                Der Einsatz des Hosters erfolgt zum Zwecke der Vertragserfüllung gegenüber unseren potenziellen
                und bestehenden Kunden (Art. 6 Abs. 1 lit. b DSGVO) und im Interesse einer sicheren, schnellen
                und effizienten Bereitstellung unseres Online-Angebots (Art. 6 Abs. 1 lit. f DSGVO). Sofern eine
                entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschließlich auf Grundlage
                von Art. 6 Abs. 1 lit. a DSGVO; die Einwilligung ist jederzeit widerrufbar.
              </p>
              <p className="mt-3">
                <strong className="text-slate-800">Auftragsverarbeitung:</strong><br />
                Wir haben mit dem Anbieter einen Vertrag über Auftragsverarbeitung (AVV) gemäß Art. 28 DSGVO
                geschlossen. Dies ist ein datenschutzrechtlich vorgeschriebener Vertrag, der gewährleistet, dass
                der Hoster die personenbezogenen Daten unserer Websitebesucher nur nach unseren Weisungen und
                unter Einhaltung der DSGVO verarbeitet. Die Datenübertragung in die USA wird dabei auf die
                Standardvertragsklauseln der EU-Kommission gestützt.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 font-['Outfit'] mb-3">4. Ihre Rechte</h2>
              <p>Sie haben jederzeit das Recht auf:</p>
              <ul className="mt-2 space-y-1 list-disc list-inside text-slate-600">
                <li>Auskunft über Ihre gespeicherten personenbezogenen Daten (Art. 15 DSGVO)</li>
                <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
                <li>Löschung Ihrer Daten (Art. 17 DSGVO)</li>
                <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
                <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
                <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
                <li>Widerruf einer erteilten Einwilligung (Art. 7 Abs. 3 DSGVO)</li>
                <li>Beschwerderecht bei einer Aufsichtsbehörde (Art. 77 DSGVO)</li>
              </ul>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 font-['Outfit'] mb-3">5. Cookies</h2>
              <p>
                Unsere Website verwendet Cookies. Cookies sind kleine Textdateien, die auf Ihrem Endgerät
                gespeichert werden. Sie richten keinen Schaden an und enthalten keine Viren.
              </p>
              <p className="mt-3">
                <strong className="text-slate-800">Notwendige Cookies:</strong> Diese Cookies sind für den Betrieb der Website
                erforderlich und können nicht deaktiviert werden. Sie werden in der Regel als Reaktion auf
                von Ihnen getätigte Aktionen gesetzt, die einer Dienstanforderung entsprechen (z. B.
                Cookie-Einstellungen). Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO.
              </p>
              <p className="mt-3">
                <strong className="text-slate-800">Analyse-Cookies:</strong> Diese Cookies werden nur mit Ihrer ausdrücklichen
                Einwilligung gesetzt (Opt-in) und ermöglichen uns, die Nutzung der Website zu analysieren
                und das Angebot zu verbessern. Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO. Die Einwilligung
                können Sie jederzeit über unser Cookie-Banner widerrufen.
              </p>
              <p className="mt-3">
                Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert
                werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle
                oder generell ausschließen. Bei der Deaktivierung von Cookies kann die Funktionalität
                dieser Website eingeschränkt sein.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 font-['Outfit'] mb-3">6. Kontaktformular</h2>
              <p>
                Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem
                Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten (Name, Firma, E-Mail,
                Ihre Vision/Nachricht) zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen
                bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
              </p>
              <p className="mt-3">
                Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage
                mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher
                Maßnahmen erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem
                berechtigten Interesse (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer Einwilligung
                (Art. 6 Abs. 1 lit. a DSGVO).
              </p>
              <p className="mt-3">
                Die Daten verbleiben bei uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung
                widerrufen oder der Zweck für die Datenspeicherung entfällt. Zwingende gesetzliche
                Bestimmungen – insbesondere Aufbewahrungsfristen – bleiben unberührt.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 font-['Outfit'] mb-3">7. Lokal eingebundene Assets</h2>
              <p>
                Diese Website nutzt, soweit möglich, lokal eingebundene Schriftarten und Medien-Assets.
                Beim Aufruf einer Seite werden keine Verbindungen zu externen Servern Dritter für das
                Laden von Designelementen hergestellt, sofern diese auf unserem eigenen Server bereitgestellt
                werden. Eine Übertragung Ihrer IP-Adresse an externe Drittanbieter findet in diesem
                Zusammenhang nicht statt. Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 font-['Outfit'] mb-3">8. SSL-/TLS-Verschlüsselung</h2>
              <p>
                Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher
                Inhalte eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen
                Sie daran, dass die Adresszeile des Browsers von „http://" auf „https://" wechselt und
                an dem Schloss-Symbol in Ihrer Browserzeile.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 font-['Outfit'] mb-3">9. Aktualität dieser Datenschutzerklärung</h2>
              <p>
                Diese Datenschutzerklärung ist aktuell gültig und hat den Stand April 2026. Durch die
                Weiterentwicklung unserer Website oder aufgrund geänderter gesetzlicher bzw. behördlicher
                Vorgaben kann es notwendig werden, diese Datenschutzerklärung zu ändern. Die jeweils
                aktuelle Version kann jederzeit auf dieser Seite abgerufen werden.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
